<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>
  mat-accordion {
    width: 100%;
  }
  .example-headers-align .mat-expansion-panel-header-description {
    display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  }

  mat-panel-title {
    text-align: center !important;
  }

 .mat-form-field-prefix {
  top: 0!important;
}

.example-right-align {
  text-align: right;
}

input.example-right-align::-webkit-outer-spin-button,
input.example-right-align::-webkit-inner-spin-button {
  display: none;
}

input.example-right-align {
  -moz-appearance: textfield;
}
  table {
  width: 100%;
}
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    height: 60px;
    margin: -8px;
    display: flex;
    align-items: center;
    background-color: #7b1fa2;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: flex;
    margin: 32px auto;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(black, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #424242;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: 100vh;
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #1976d2;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
    border-color: rgba(27,31,35,.35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }


  /* Responsive Styles */
  @media screen and (max-width: 767px) {

    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }
</style>

<!-- Toolbar -->
<div class="toolbar" role="banner">
  <span style="margin-left:25px">job 2 job</span>
    <div class="spacer"></div>

  <a *ngIf="false" aria-label="Angular on twitter" href="https://twitter.com/angular" title="Twitter">
    
    <svg id="twitter-logo" height="24" data-name="Logo — FIXED" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }

          .cls-2 {
            fill: #ffffff;
          }
        </style>
      </defs>
      <rect class="cls-1" width="400" height="400" />
      <path class="cls-2" d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23"
      />
    </svg>
    
  </a>
  <button mat-raised-button color="secondary" style="margin-right: 25px;" (click)="openDisclaimer()">
        Acerca de
      </button>
</div>

<div class="content" role="main">

  <!-- Highlight Card -->
  <div class="card highlight-card card-small">

    <svg id="rocket" alt="Rocket Ship" xmlns="http://www.w3.org/2000/svg" width="101.678" height="101.678" viewBox="0 0 101.678 101.678">
      <g id="Group_83" data-name="Group 83" transform="translate(-141 -696)">
        <circle id="Ellipse_8" data-name="Ellipse 8" cx="50.839" cy="50.839" r="50.839" transform="translate(141 696)" fill="#f5f5f5"/>
        <g id="Group_47" data-name="Group 47" transform="translate(165.185 720.185)">
          <path id="Path_33" data-name="Path 33" d="M3.4,42.615a3.084,3.084,0,0,0,3.553,3.553,21.419,21.419,0,0,0,12.215-6.107L9.511,30.4A21.419,21.419,0,0,0,3.4,42.615Z" transform="translate(0.371 3.363)" fill="#9b5412"/>
          <path id="Path_34" data-name="Path 34" d="M53.3,3.221A3.09,3.09,0,0,0,50.081,0,48.227,48.227,0,0,0,18.322,13.437c-6-1.666-14.991-1.221-18.322,7.218A33.892,33.892,0,0,1,9.439,25.1l-.333.666a3.013,3.013,0,0,0,.555,3.553L23.985,43.641a2.9,2.9,0,0,0,3.553.555l.666-.333A33.892,33.892,0,0,1,32.647,53.3c8.55-3.664,8.884-12.326,7.218-18.322A48.227,48.227,0,0,0,53.3,3.221ZM34.424,9.772a6.439,6.439,0,1,1,9.106,9.106,6.368,6.368,0,0,1-9.106,0A6.467,6.467,0,0,1,34.424,9.772Z" transform="translate(0 0.005)" fill="#222831"/>
        </g>
      </g>
    </svg>

    <span>¿Cuantas posiciones quieres comparar?</span>
    
    <svg id="rocket-smoke" alt="Rocket Ship Smoke" xmlns="http://www.w3.org/2000/svg" width="516.119" height="1083.632" viewBox="0 0 516.119 1083.632">
      <path id="Path_40" data-name="Path 40" d="M644.6,141S143.02,215.537,147.049,870.207s342.774,201.755,342.774,201.755S404.659,847.213,388.815,762.2c-27.116-145.51-11.551-384.124,271.9-609.1C671.15,139.365,644.6,141,644.6,141Z" transform="translate(-147.025 -140.939)" fill="#f5f5f5"/>
    </svg>

  </div>

  <!-- Resources -->
  <div class="card-container">
    <div class="example-button-container">
      <button mat-fab color="primary" (click)="removeCompany()">
        <mat-icon>remove</mat-icon>
      </button>
    </div>
    <mat-form-field appearance="outline" [style.width.px]=90 [style.padding-left.px]=30 [style.padding-right.px]=30>
      <input readonly style="text-align: center; color:#eee" matInput type="text" class="example-right-align" [(ngModel)]="amountCompanies">
    </mat-form-field>
    <div class="example-button-container">
      <button mat-fab color="primary" (click)="addCompany()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>

  <table mat-table fixedLayout="true" [dataSource]="companies" class="mat-elevation-z8" style="margin-bottom: 50px; margin-top:50px; text-align: center;">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Position Column
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> No. </th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container> -->
  
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Nombre </th>
      <td mat-cell *matCellDef="let element">
        <!--  {{element.name}}  -->
         <mat-form-field appearance="outline" [style.width]="'100%'">
          <input matInput [(ngModel)]="element.name">
          <mat-hint>Posición @ Compañía</mat-hint>
        </mat-form-field>
        </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="salary">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Salario </th>
      <td mat-cell *matCellDef="let element"> 
        <mat-form-field appearance="outline" [style.width.px]=120 floatLabel="always" >
          <mat-hint>Mensual</mat-hint>
          <input 
            matInput 
            type="number" 
            onfocus="this.select()"
            (ngModelChange)="updateSalaryAnualized(element, $event)"
            [(ngModel)]="element.salary">
        </mat-form-field>
       </td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="hiringTypeId">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Contrato </th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field appearance="outline" [style.width]="'100%'" >
          <mat-select [(ngModel)]="element.hiringTypeId" (ngModelChange)="updateSalaryAnualized(element)">
            <mat-option *ngFor="let item of defaultHiringTypes" [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
          <mat-hint>Indique un tipo de contratación</mat-hint>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="vacationDays">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Días vacaciones </th>
      <td mat-cell *matCellDef="let element"> 
        <mat-form-field appearance="outline" [style.width.px]=100 floatLabel="always" >
          <mat-hint>Al año</mat-hint>
          <input 
            matInput 
            type="number" 
            onfocus="this.select()"
            class="example-right-align" 
            [(ngModel)]="element.vacationDays">
        </mat-form-field>
       </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <div class="benefits-card">
    <h3>Elige los beneficios que apliquen para cada posición</h3>
  </div>

  <div class="grid-benefits">
    <div class="button-benefit" *ngFor="let benefit of defaulBenefits; last as last" role="listitem">
      <button mat-raised-button color="primary" style="display: block;
      margin-left: auto;
      margin-right: auto;" (click)="openDialog(benefit)">
        <mat-icon>add</mat-icon>
        {{benefit.displayName}}
      </button>
    </div>
  </div>


  <mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel disabled hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-description style="color: #888; width:25px; font-weight: 500">
          Nombre
        </mat-panel-description>
        <mat-panel-description style="color: #888; width:25px; font-weight: 500">
          Anualizado
        </mat-panel-description>
        <mat-panel-description style="color: #888; width:25px; font-weight: 500">
          Impuestos*
        </mat-panel-description>
        <mat-panel-description style="color: #888; width:25px; font-weight: 500">
          Anualizado neto*
        </mat-panel-description>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel *ngFor="let company of companies; last as last">
      <mat-expansion-panel-header>
        <mat-panel-description  style="width:25px">
          <mat-form-field appearance="fill" [style.width]="'100%'">
            <input disabled matInput [(ngModel)]="company.name">
          </mat-form-field>
        </mat-panel-description>
        <mat-panel-description style="width:25px">
          <span>
            {{ company.salaryAnualized | currency }}
          </span>
        </mat-panel-description>
        <mat-panel-description style="width:25px">
          <span>
            {{ company.totalTaxes | currency}}
          </span>
        </mat-panel-description>
        <mat-panel-description style="width:25px">
          <span>
            {{ company.netSalary | currency }}
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div *ngIf="company.salary > 0">
        <h3>Salario</h3>
        <p><b>Mensual: </b>{{company.salary|currency}} <span *ngIf="company.hiringTypeId===1"> - <b>Impuestos: </b>{{company.taxes["0"] | currency}}</span>  -  <b>Anual: </b>{{company.salary*12|currency}}</p>
      </div>
      <div *ngFor="let item of company.benefits | keyvalue">
        <div *ngIf="item.value.value > 0">
          <h3>{{item.value.displayName}}</h3>
          
          <p *ngIf="item.value.type === 1"><b>Días: </b>{{item.value.value}} - <b>Impuestos: </b>{{company.taxes[item.value.id.toString()] | currency}} - <b>Anual: </b>{{(company.salary/30)* item.value.value | currency}}</p>
          <p *ngIf="item.value.type === 2"><b>Porc: </b>{{item.value.value}} - <b>Impuestos: </b>{{company.taxes[item.value.id.toString()] | currency}} - <b>Anual: </b>{{(company.salary/30) * company.vacationDays * (item.value.value/100) | currency}}</p>
          <p *ngIf="item.value.type === 3"><b>Mensual: </b>{{item.value.value | currency}} - <b>Anual: </b>{{item.value.value*12 | currency}}</p>
          <p *ngIf="item.value.type === 4"><span *ngIf="company.hiringTypeId===1 && company.taxes[item.value.id.toString()]"><b>Impuestos: </b>{{company.taxes[item.value.id.toString()] | currency}} - </span><b>Anual: </b>{{item.value.value | currency}}</p>
          <p *ngIf="item.value.type === 5"><b>Único: </b>{{item.value.value | currency}}</p>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  
  <div style="margin-top: 60px; background-color: #f5f5f581; border-radius: 0.75%;">
  <ngx-charts-bar-vertical
    [view]="view"
    [scheme]="colorScheme"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [rotateXAxisTicks]="rotateXAxisTicks">
  </ngx-charts-bar-vertical>
  </div>

  <!-- Footer -->
  <footer class="footer">
      Hecho en 🇲🇽 con 💜 por <span class="sign">Chan</span>
  </footer>

  <svg id="clouds" alt="Gray Clouds Background" xmlns="http://www.w3.org/2000/svg" width="2611.084" height="485.677" viewBox="0 0 2611.084 485.677">
    <path id="Path_39" data-name="Path 39" d="M2379.709,863.793c10-93-77-171-168-149-52-114-225-105-264,15-75,3-140,59-152,133-30,2.83-66.725,9.829-93.5,26.25-26.771-16.421-63.5-23.42-93.5-26.25-12-74-77-130-152-133-39-120-212-129-264-15-54.084-13.075-106.753,9.173-138.488,48.9-31.734-39.726-84.4-61.974-138.487-48.9-52-114-225-105-264,15a162.027,162.027,0,0,0-103.147,43.044c-30.633-45.365-87.1-72.091-145.206-58.044-52-114-225-105-264,15-75,3-140,59-152,133-53,5-127,23-130,83-2,42,35,72,70,86,49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33,61.112,8.015,113.854-5.72,150.492-29.764a165.62,165.62,0,0,0,110.861-3.236c47,94,178,113,251,33,31.385,4.116,60.563,2.495,86.487-3.311,25.924,5.806,55.1,7.427,86.488,3.311,73,80,204,61,251-33a165.625,165.625,0,0,0,120,0c51,13,108,15,157-5a147.188,147.188,0,0,0,33.5-18.694,147.217,147.217,0,0,0,33.5,18.694c49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33C2446.709,1093.793,2554.709,922.793,2379.709,863.793Z" transform="translate(142.69 -634.312)" fill="#eee"/>
  </svg>

</div>
<router-outlet></router-outlet>